import { useMutation } from 'react-query';

import {
  GroupSubscriptionConfirmParams,
  confirmGroupSubscription,
} from '../utils/backend-api/groupSubscription';

export default function useGroupSubscriptionConfirm() {
  const { mutateAsync, data, isLoading, isError } = useMutation(
    (params: GroupSubscriptionConfirmParams) => confirmGroupSubscription(params)
  );
  return { mutateAsync, data, isLoading, isError };
}
